import { createAction } from 'redux-actions';
import {
  ARTICLE_LIST_FETCH,
  ARTICLE_LIST_SUCCESS,
  ARTICLE_LIST_FAILURE,
  DELETE_ARTICLE_FETCH,
  DELETE_ARTICLE_SUCCESS,
  DELETE_ARTICLE_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-ARTICLES--->>>
export const articleListFetch = createAction(ARTICLE_LIST_FETCH);
export const articleListSuccess = createAction(ARTICLE_LIST_SUCCESS);
export const articleListFailure = createAction(ARTICLE_LIST_FAILURE);

export const fetchArticles = () => async dispatch => {
  dispatch(articleListFetch());
  try {
    const res = await api.get('article');
    dispatch(articleListSuccess(res.data));
  } catch (error) {
    dispatch(articleListFailure(error));
  }
};

//<<<---DELETE-ARTICLE--->>>
export const deleteArticleFetch = createAction(DELETE_ARTICLE_FETCH);
export const deleteArticleSuccess = createAction(DELETE_ARTICLE_SUCCESS);
export const deleteArticleFailure = createAction(DELETE_ARTICLE_FAILURE);

export const deleteArticle = (id, lang, callback) => async dispatch => {
  dispatch(deleteArticleFetch());
  try {
    const res = await api.post(`article/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteArticleSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteArticleFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ArticleList/actions.js